import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getAuthMe, isApiConfigured } from "../apiClient";
import { resolveVerificationRedirect } from "../navigateAfterAuth";

/**
 * Sends signed-in users who have not finished email/mobile verification back to the
 * verify flow when they hit applicant or hiring routes.
 */
export default function VerificationGate({ currentUser, setCurrentUser, authToken }) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isApiConfigured() || !authToken) return;
    let cancelled = false;
    (async () => {
      try {
        const { user } = await getAuthMe(authToken);
        if (cancelled || !user) return;
        setCurrentUser(user);
      } catch {
        /* keep cached session user */
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [authToken, setCurrentUser]);

  useEffect(() => {
    const target = resolveVerificationRedirect(
      currentUser,
      location.pathname,
      location.search
    );
    if (target) {
      navigate(target, { replace: true });
    }
  }, [currentUser, location.pathname, location.search, navigate]);

  return null;
}
